import React from "react";
import BookingScheduleBooking from "../booking/ScheduleBooking";
import BookingMemberBooking from "../booking/MemberBooking";
import type { ScheduleBookingConfig, MemberBookingConfig } from "./types";

/**
 * Render the correct booking component from a config object.
 * Templates call this instead of importing booking components directly.
 */
export function renderBooking(
  booking: ScheduleBookingConfig | MemberBookingConfig,
): React.ReactNode {
  if (booking.type === "schedule") {
    const { type, ...props } = booking;
    return <BookingScheduleBooking {...props} />;
  }
  const { type, ...props } = booking;
  return <BookingMemberBooking {...props} />;
}
